import React from "react";

export default (props) => {
  return <img {...props} style={{ ...props.style, objectFit: "cover" }} />;
};
